<i class="far fa-ellipsis-v btn-xs btn-icon simple-icon"
    [popover]="timesDetails"
    container="body"
    containerClass="confirmation-popover"
    placement="right"
    triggers="mouseenter mouseleave"
    containerClass="many-to-one-popover"
    #pop="bs-popover"></i>
<ng-template #timesDetails>
    <table class="m-0 table-small">
        <thead>
            <tr>
                <th>{{ 'Last modified' | translate }}</th>
                <th>{{ 'Created' | translate }}</th>
            </tr>
        </thead>
        <tbody>
            <tr>
                <td>
                    <small>{{ service.lastChangedBy }}</small>
                    <br>
                    <small><b>{{ service.lastChangedWhen | date: 'dd-MM-yyyy' }}</b></small>
                </td>
                <td>
                    <small>{{ service.createdBy }}</small>
                    <br>
                    <small><b>{{ service.createdWhen | date: 'dd-MM-yyyy' }}</b></small>
                </td>
            </tr>
        </tbody>
    </table>
</ng-template>